export default __webpack_public_path__ + "static/media/product_mid.55d3ac0b657d1dfda25eda9a071cbe61.svg";